import { post } from '../../../util/api'
import { SAVE_VIEW_PREFERENCES } from '../../globals/state/type'
import * as type from './type'
import { TYPE_PREFIX } from './type'
import {selectUserViewPreferences} from "../../globals/state/selector";
import debounce from 'lodash/debounce'

let controller = window.AbortController && new window.AbortController()

const stopRunningAndCreateSignal = () => {
    if (controller) {
        controller.abort()
    }
    controller = new window.AbortController()
    return controller.signal
}

let saveTimeout = null;
let SAVE_DELAY = 2000; //two seconds delay to prevent multiple save operations when changing column visibility too fast


const queryTable = (dispatch, state, tableName, selectOwnState, afterLoad) => {
    const localState = selectOwnState(state)
    const request = localState[tableName]
    const signal = stopRunningAndCreateSignal()

    post('/api/table/execute-table-query', request, signal)
        .then(objectList => {
            if (afterLoad) {
                afterLoad(state, objectList)
            }
            dispatch({
                type: TYPE_PREFIX + tableName + type.QUERY_SUCCESS,
                payload: {
                    objectList,
                },
            })
        })
        .catch(error => {
            dispatch({
                type: TYPE_PREFIX + tableName + type.QUERY_ERROR,
                payload: {
                    error,
                },
            })
        })
}

export const createInitialTableQueryAction = (selectOwnState, tableName, afterLoad) => () => (dispatch, getState) => {
    dispatch({
        type: TYPE_PREFIX + tableName + type.QUERY_REQUEST,
    })
    queryTable(dispatch, getState(), tableName, selectOwnState, afterLoad)
}

const saveTableConfigurationInBackend = (getState) => {
    const viewPreferences = selectUserViewPreferences(getState());
    post('/api/security/user/save-view-preferences', viewPreferences)
        .then(() => {
            //no actions needed
        });
}

const saveTableConfigurationDelayed = (getState) => {
    if (saveTimeout) {
        clearTimeout(saveTimeout);
    }

    saveTimeout = setTimeout(() => {
        saveTimeout = null;
        saveTableConfigurationInBackend(getState);
    }, SAVE_DELAY);
}

const createNewViewPreferences = (getState, tableName, columns) => {
    const viewPreferences = selectUserViewPreferences(getState());
    const { tableSettings } = viewPreferences;

    const newTableSettings = {
        ...tableSettings,
        [tableName] : {
            hiddenColumns: columns
        }
    }

    return {
        ...viewPreferences,
        tableSettings: newTableSettings
    }
}

const saveTableConfiguration = (getState, tableName, columns, dispatch) => {
    const newViewPreferences = createNewViewPreferences(getState, tableName, columns)
    saveTableConfigurationDelayed(getState)

    dispatch({
        type: SAVE_VIEW_PREFERENCES,
        payload: newViewPreferences
    })
}

const toggleColumnVisibility = (hiddenColumns, columnName) => {
    const newHiddenColumns = [...hiddenColumns];
    if (newHiddenColumns.includes(columnName)) {
        newHiddenColumns.splice(newHiddenColumns.indexOf(columnName), 1);
    } else {
        newHiddenColumns.push(columnName);
    }
    return newHiddenColumns;
}

export const createToggleColumnVisibilityTableHandler = (selectOwnState, tableName) => (columnName) => (dispatch, getState) => {
    const tableSetting = selectOwnState(getState())
    const hiddenColumns = toggleColumnVisibility(tableSetting.hiddenColumns, columnName)
    const actionName = TYPE_PREFIX + tableName + type.SET_HIDDEN_COLUMNS;
    saveTableConfiguration(getState, tableName, hiddenColumns, dispatch)
    dispatch({
        type: actionName,
        payload: hiddenColumns
    })
}

export const createToggleColumnVisibilityFormHandler = (selectOwnState, settingActionName, tableName) => (columnName) => (dispatch, getState) => {
    const { tableSetting } = selectOwnState(getState())
    const hiddenColumns = toggleColumnVisibility(tableSetting.hiddenColumns, columnName)
    saveTableConfiguration(getState, tableName, hiddenColumns, dispatch)
    dispatch({
        "type": settingActionName,
        payload: {
            'name':'hiddenColumns', 'value': hiddenColumns,
        },
    })

}

const getTableHiddenColumns = (tableName, getState) => {
    const viewPreferences = selectUserViewPreferences(getState())
    const { tableSettings } = viewPreferences;

    if (!tableSettings) {
        return [];
    }

    if (!tableSettings.hasOwnProperty(tableName)) {
        return [];
    }
    const theTableSettings = tableSettings[tableName];
    if (!theTableSettings.hasOwnProperty('hiddenColumns')) {
        return [];
    }
    return [...theTableSettings.hiddenColumns]
}


export const createInitialColumnsVisibilityTableHandler = (tableName) => () => (dispatch, getState) => {
    const hiddenColumns = getTableHiddenColumns(tableName, getState)
    const actionName = TYPE_PREFIX + tableName + type.SET_HIDDEN_COLUMNS;
    dispatch({
        type: actionName,
        payload: hiddenColumns
    })
}

export const createInitialColumnsVisibilityFormHandler = (tableName, actionName) => () => (dispatch, getState) => {
    const hiddenColumns = getTableHiddenColumns(tableName, getState)
    dispatch({
        type: actionName,
        payload: {
            name: 'hiddenColumns',
            value: hiddenColumns
        }
    })
}

const debouncedQueryTable = debounce(queryTable, 1000, false)

export const createChangeFilterAction = (selectOwnState, tableName, afterLoad) => (columnName, filterValue) => (dispatch, getState) => {
    dispatch({
        type: TYPE_PREFIX + tableName + type.CHANGE_FILTER,
        payload: {
            columnName,
            filterValue,
        },
    })
    debouncedQueryTable(dispatch, getState(), tableName, selectOwnState, afterLoad)
}

export const createToggleSortAction = (selectOwnState, tableName, afterLoad) => (columnName) => (dispatch, getState) => {
    dispatch({
        type: TYPE_PREFIX + tableName + type.TOGGLE_SORT,
        payload: {
            columnName,
        },
    })
    queryTable(dispatch, getState(), tableName, selectOwnState, afterLoad)
}

export const createToggleMultiSortAction = (selectOwnState, tableName, afterLoad) => (columnName) => (dispatch, getState) => {
    dispatch({
        type: TYPE_PREFIX + tableName + type.TOGGLE_MULTI_SORT,
        payload: {
            columnName,
        },
    })
    queryTable(dispatch, getState(), tableName, selectOwnState, afterLoad)
}

export const createGotoPageAction = (tableName) => (page) => ({
    type: TYPE_PREFIX + tableName + type.GOTO_PAGE,
    payload: {
        page,
    },
})



// WEBPACK FOOTER //
// ./src/modules/table/state/action.js